import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App.tsx"
import { LocaleProvider } from "./i18n/index.tsx"
import { SessionProvider } from "./auth/SessionProvider.tsx"
import { ToastProvider } from "./ui/Toast.tsx"
import { ThemeProvider } from "./ui/theme.tsx"
import "./styles/index.css"

const container = document.getElementById("root")
if (!container) throw new Error("#root 가 없습니다")

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <LocaleProvider>
        <ToastProvider>
          <SessionProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SessionProvider>
        </ToastProvider>
      </LocaleProvider>
    </ThemeProvider>
  </StrictMode>,
)
